// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pj-z","carouselContainer":"qj-z","carouselContent":"rj-z"};